const getWebchatUrl = (parentUrl) => {
	if (parentUrl.includes('localhost:3000')) {
		return 'http://localhost:5001';
	}

	if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
		return 'https://staging-chat.chekkit.io';
	}

	if (parentUrl.includes('evanov') || parentUrl.includes('radio')) {
		return 'https://chat2.chekkit.io';
	}

	return 'https://chat.chekkit.io';
};

export default getWebchatUrl;
